import { render, staticRenderFns } from "./UploadItem.vue?vue&type=template&id=70c137ee"
import script from "./UploadItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports